import { InjectionToken } from "@angular/core";
import { ReconciliationDaysPort } from "./reconciliation-days.port";

export const RECONCILIATION_DAYS_PORT = new InjectionToken<ReconciliationDaysPort>("RECONCILIATION_DAYS_PORT");
